import { render, staticRenderFns } from "./InstagramPopover.vue?vue&type=template&id=0219792a&scoped=true&"
import script from "./InstagramPopover.vue?vue&type=script&lang=js&"
export * from "./InstagramPopover.vue?vue&type=script&lang=js&"
import style0 from "./InstagramPopover.vue?vue&type=style&index=0&id=0219792a&prod&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0219792a",
  null
  
)

export default component.exports